import { render, staticRenderFns } from "./PriceWithCrossedPrice.vue?vue&type=template&id=310af65a&"
import script from "./PriceWithCrossedPrice.vue?vue&type=script&lang=js&"
export * from "./PriceWithCrossedPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports